import { render } from "./ProHeaderNotLogged.vue?vue&type=template&id=2b71bd1e"
import script from "./ProHeaderNotLogged.vue?vue&type=script&lang=js"
export * from "./ProHeaderNotLogged.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__